'use client';

import Link from 'next/link';
import { useState } from 'react';

export default function RecoverPassword() {
  const [email, setEmail] = useState('');

  return (
    <>
      <div className="user-form-card">
        <div className="user-form-title">
          <h2>استعادة كلمة المرور</h2>
          <p>قم بإدخال البريد الالكتروني</p>
        </div>
        <form className="user-form">
          <div className="form-group">
            <input
              type="email"
              className="form-control"
              placeholder="البريد الإلكتروني"
              required
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="form-button">
            <button type="submit" className="ps-btn ps-btn--warning">
              <Link href={`/verification-code?vrfem=${email}`}>استعادة</Link>
            </button>
          </div>
        </form>
      </div>
      <div className="user-form-remind">
        <p>
          تذكرت كلمة المرور ؟<Link href="/login">العودة الي تسجيل الدخول</Link>
        </p>
      </div>
      <div className="user-form-footer">
        <p>جميع الحقوق محفوظة شركه زمزم © 2024</p>
      </div>
    </>
  );
}
